import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

const VersionCheckPage = () => {
  const [checks, setChecks] = useState({
    version: 'جاري الفحص...',
    permissions: 'جاري الفحص...',
    serviceWorker: 'جاري الفحص...',
    localStorage: 'جاري الفحص...',
    timestamp: new Date().toLocaleString('ar-SA')
  });

  useEffect(() => {
    const runChecks = async () => {
      const newChecks = { ...checks };

      // 1. Check version
      newChecks.version = '2.0.0 - محدثة ✅';

      // 2. Check localStorage
      const adminUser = localStorage.getItem('admin_user');
      if (adminUser) {
        try {
          const user = JSON.parse(adminUser);
          if (user.permissions && user.permissions.includes('*')) {
            newChecks.localStorage = `✅ موجود مع permissions: ['*']`;
          } else {
            newChecks.localStorage = `⚠️ موجود لكن بدون permissions`;
          }
        } catch (e) {
          newChecks.localStorage = `❌ خطأ في القراءة`;
        }
      } else {
        newChecks.localStorage = '❌ غير موجود - يجب تسجيل الدخول';
      }

      // 3. Check Service Workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        if (registrations.length > 0) {
          newChecks.serviceWorker = `⚠️ يوجد ${registrations.length} service worker نشط`;
        } else {
          newChecks.serviceWorker = '✅ لا يوجد service workers';
        }
      } else {
        newChecks.serviceWorker = '✅ غير مدعوم';
      }

      // 4. Check permissions in code
      newChecks.permissions = '✅ الكود محدث - يضيف permissions تلقائياً';

      setChecks(newChecks);
    };

    runChecks();
  }, []);

  const clearEverything = async () => {
    try {
      // Clear storage
      localStorage.clear();
      sessionStorage.clear();
      
      // Unregister service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
          console.log('✅ Service Worker unregistered');
        }
      }
      
      // Delete all caches
      if ('caches' in window) {
        const names = await caches.keys();
        for (let name of names) {
          await caches.delete(name);
          console.log('✅ Cache deleted:', name);
        }
      }
      
      alert('✅ تم مسح كل شيء بنجاح!\n\n- Service Workers: تم إلغاؤها\n- Cache: تم مسحها\n- Storage: تم تنظيفها\n\nسيتم إعادة تحميل الصفحة...');
      
      // Hard reload
      setTimeout(() => {
        window.location.href = window.location.href + '?t=' + Date.now();
      }, 500);
      
    } catch (error) {
      alert('حدث خطأ: ' + error.message);
      console.error('Error clearing:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#1E3A8A] to-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-[#1E3A8A] rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl text-white">🔍</span>
          </div>
          <h1 className="text-3xl font-black text-[#1E3A8A] mb-2">صفحة فحص النظام</h1>
          <p className="text-gray-600">تحقق من حالة التطبيق والذاكرة المؤقتة</p>
        </div>

        {/* Checks */}
        <div className="space-y-4 mb-8">
          <div className="p-4 bg-blue-50 rounded-xl border-2 border-blue-200">
            <h3 className="font-bold text-blue-900 mb-2">📦 إصدار التطبيق</h3>
            <p className="text-blue-800 font-mono text-sm">{checks.version}</p>
          </div>

          <div className="p-4 bg-green-50 rounded-xl border-2 border-green-200">
            <h3 className="font-bold text-green-900 mb-2">✅ نظام الصلاحيات</h3>
            <p className="text-green-800 text-sm">{checks.permissions}</p>
          </div>

          <div className="p-4 bg-purple-50 rounded-xl border-2 border-purple-200">
            <h3 className="font-bold text-purple-900 mb-2">💾 التخزين المحلي</h3>
            <p className="text-purple-800 text-sm">{checks.localStorage}</p>
          </div>

          <div className="p-4 bg-orange-50 rounded-xl border-2 border-orange-200">
            <h3 className="font-bold text-orange-900 mb-2">⚙️ Service Workers</h3>
            <p className="text-orange-800 text-sm">{checks.serviceWorker}</p>
          </div>

          <div className="p-4 bg-gray-50 rounded-xl border-2 border-gray-200">
            <h3 className="font-bold text-gray-900 mb-2">🕐 وقت الفحص</h3>
            <p className="text-gray-800 text-sm font-mono">{checks.timestamp}</p>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={clearEverything}
            className="w-full px-6 py-3 bg-red-600 text-white rounded-xl font-bold hover:bg-red-700 transition-all"
          >
            🗑️ مسح كل شيء وإعادة التحميل
          </button>
          
          <button
            onClick={() => window.location.href = '/admin/login'}
            className="w-full px-6 py-3 bg-[#1E3A8A] text-white rounded-xl font-bold hover:bg-[#152d6e] transition-all"
          >
            🔐 الذهاب لتسجيل الدخول
          </button>

          <button
            onClick={() => window.location.href = '/'}
            className="w-full px-6 py-3 bg-gray-600 text-white rounded-xl font-bold hover:bg-gray-700 transition-all"
          >
            🏠 الصفحة الرئيسية
          </button>
        </div>

        {/* Instructions */}
        <div className="mt-8 p-4 bg-yellow-50 border-2 border-yellow-200 rounded-xl">
          <h4 className="font-bold text-yellow-900 mb-2">📋 تعليمات:</h4>
          <ol className="text-sm text-yellow-800 space-y-2 list-decimal list-inside">
            <li>اضغط على زر "مسح كل شيء"</li>
            <li>انتظر إعادة تحميل الصفحة</li>
            <li>اذهب لتسجيل الدخول</li>
            <li>يجب أن تظهر البطاقات الأربع!</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default VersionCheckPage;
